// extracted by mini-css-extract-plugin
export default {"wrapper":"bUyChhvHfNvVkqF_C6nl","dateField":"OsMu5v36NgNmdBjlsIy0"};